<template>
  <div class="calculator-banner" v-if="getHeaderImage !== ''">
    <img :src="getHeaderImage" alt="Calculator Banner" class="full-width" />
  </div>
</template>

<script>
import { QBtn } from 'quasar';
import { mapGetters } from 'vuex';
export default {
  name: 'CalculatorBanner',
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      calculator: 'theme/getCalculator',
      scoreboard: 'theme/getScoreboard'
    }),
    getHeaderImage() {
      return this.calculator?.headerImage ? this.calculator.headerImage : '';
    }
  }
};
</script>

<style lang="sass" scoped>
.calculator-banner
  left: 50%
  margin-left: -50vw
  margin-right: -50vw
  max-width: 100vw
  position: relative
  right: 50%
  width: 100vw
  margin-bottom: 25px
</style>
